import React, {useState, useEffect,Dispatch, useMemo, useContext, useRef, SetStateAction} from "react";
import { InputFilter } from "../inputFilter/inputFilter"; 
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import "./filter.css"
import "../style/styleText.css"
import { principalCuisine } from "../types/types";
import { FiCheck } from "react-icons/fi";
import { startTransition } from 'react';
import { AppContext } from "../../context/AppContext";
import { useLocation, useNavigate } from "react-router-dom";

interface FilterInterface {
    value : string,
    liste: string[],
    isLast?:boolean,

    allDelete?:boolean,
    listFilter: (string | number |[number,number])[],
    setListFilter: Dispatch<React.SetStateAction<(string | number |[number,number])[]>>,
    searchValue: string,
    setShowAll: Dispatch<React.SetStateAction<number>>,
    checkPrice:(min:number,max:number) => void,
    checkDistance:(distance:number) => void,
    isEditing?:boolean,
    baseClose?:boolean,
    resetSearchResto?:() => void,
    setBaseClose?:Dispatch<SetStateAction<boolean>>
}


const Filter:React.FC<FilterInterface> = ({isLast=false,baseClose=false,setBaseClose,isEditing=false,checkPrice,checkDistance,resetSearchResto,value,liste,allDelete=false,listFilter,setListFilter,searchValue,setShowAll}) => {
    const {setDate_selected,setHour_selected,setValueSearchCity,setSearchCity,setCoordonates} = useContext(AppContext)
    const [show,setShow] = useState(!baseClose)
    const navigate = useNavigate()
    const location = useLocation();
    const getInitialValues = () => {
        const validFilter = listFilter.find(
            (filtre): filtre is [number, number] => 
                Array.isArray(filtre) && filtre.length === 2 && filtre.every(num => typeof num === "number")
        );  
        return validFilter || [0, 10];
    };
    const initialValues = useMemo(() => getInitialValues(), [listFilter]);
    
    const getPriceFromFilters = ():[number, number] | null => {
        const found = listFilter.find(
            (f): f is [number, number] =>
            Array.isArray(f) && f.length === 2 && f.every(n => typeof n === "number")
        );
        return found ?? null;
    };

    const getDistanceFromFilters = (): number | null => {
        const found = listFilter.find((f): f is number => typeof f === "number");
        return found ?? null;
    };
          

    const [minValue, setMinValue] = useState<number>(() => {
        if(isEditing) return initialValues[0]
        const p = getPriceFromFilters();
        return p ? p[0] : 0;
    });
    const [maxValue, setMaxValue] = useState<number>(() => {
        if(isEditing) return initialValues[1]
        const p = getPriceFromFilters();
        return p ? p[1] : 100;
    });
    const [distanceValue, setDistanceValue] = useState<number>(() => {
        const d = getDistanceFromFilters();
        return d ?? 10;
    });
    const distanceWrapperRef = useRef<HTMLDivElement | null>(null);
    const DIST_MIN = 0;
    const DIST_MAX = 100;
    const DIST_STEP = 5;

    const applyTimerRef = useRef<number | null>(null);
    const scheduleApply = (fn: () => void, delay = 650) => {
        if (applyTimerRef.current) window.clearTimeout(applyTimerRef.current);
        applyTimerRef.current = window.setTimeout(() => {
            applyTimerRef.current = null;
            fn();
        }, delay);
    };
    useEffect(() => {
        return () => {
            if (applyTimerRef.current) window.clearTimeout(applyTimerRef.current);
        };
    }, []);

    const PRICE_MIN = 0;
    const PRICE_MAX = 100;
    const PRICE_STEP = 10;
    
    const middle = (minValue + maxValue) / 2;
    const priceWrapperRef = useRef<HTMLDivElement | null>(null);
    const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      let value = parseInt(e.target.value);
      if (value >= maxValue - PRICE_STEP) {
        value = maxValue - PRICE_STEP; 
      }
      setMinValue(value);
      const nextMin = value;
      const nextMax = Math.max(nextMin + PRICE_STEP, maxValue);
      scheduleApply(() => {
        isEditing ? addPrice(nextMin, nextMax) : checkPrice(nextMin, nextMax);
        triggerCheckAnimation();
      });
    };
    const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      let value = parseInt(e.target.value);
      if (value <= minValue + PRICE_STEP) {
        value = minValue + PRICE_STEP; 
      }
      setMaxValue(value);
      const nextMax = value;
        const nextMin = Math.min(nextMax - PRICE_STEP, minValue);
        scheduleApply(() => {
        isEditing ? addPrice(nextMin, nextMax) : checkPrice(nextMin, nextMax);
        triggerCheckAnimation();
        });
    };
    const handleDistanceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = parseInt(e.target.value);
        if (value <= 0) {
          value = 5; 
        }
        setDistanceValue(value);
        scheduleApply(() => {
            checkDistance(value)
            triggerCheckAnimation();
        });
      };
    const updatePriceFromTouch = (e: React.TouchEvent<HTMLDivElement>,which: 'min' | 'max') => {
        e.stopPropagation();

        const wrapper = priceWrapperRef.current;
        if (!wrapper) return;

        const touch = e.touches[0];
        const rect = wrapper.getBoundingClientRect();
        const x = touch.clientX - rect.left;
        const ratio = Math.max(0, Math.min(1, x / rect.width));

        const raw = PRICE_MIN + ratio * (PRICE_MAX - PRICE_MIN);
        const clamped = Math.max(PRICE_MIN, Math.min(PRICE_MAX, raw));
        let stepped = Math.round(clamped / PRICE_STEP) * PRICE_STEP;

        if (which === 'min') {
            if (stepped >= maxValue - PRICE_STEP) {
                stepped = maxValue - PRICE_STEP; 
            }
            const nextMin = Math.min(stepped, maxValue);
            const nextMax = maxValue;
            setMinValue(nextMin);
            scheduleApply(() => {
                isEditing ? addPrice(nextMin, nextMax) : checkPrice(nextMin, nextMax);
                triggerCheckAnimation();
            }, 450);
        } else {
            if (stepped <= minValue + PRICE_STEP) {
                stepped = minValue + PRICE_STEP; 
            }
            const nextMin = minValue;
            const nextMax = Math.max(stepped, minValue);
            setMaxValue(nextMax);
            scheduleApply(() => {
                isEditing ? addPrice(nextMin, nextMax) : checkPrice(nextMin, nextMax);
                triggerCheckAnimation();
            }, 450);
        }
    };
    const handleDistanceTouch = (e: React.TouchEvent<HTMLDivElement>) => {
        e.stopPropagation();
        const wrapper = distanceWrapperRef.current;
        if (!wrapper) return;
        const touch = e.touches[0];
        const rect = wrapper.getBoundingClientRect();
        const x = touch.clientX - rect.left;
        const ratio = Math.max(0, Math.min(1, x / rect.width));

        const raw = DIST_MIN + ratio * (DIST_MAX - DIST_MIN);
        const clamped = Math.max(DIST_MIN, Math.min(DIST_MAX, raw));
        const stepped = Math.round(clamped / DIST_STEP) * DIST_STEP;
        const next = Math.max(5, stepped);
        setDistanceValue(next);
        scheduleApply(() => {
            checkDistance(next)
            triggerCheckAnimation()
        }, 450);
    };


    const clickShow = () => {
        if(setBaseClose)setBaseClose(show)
        setShow(!show)
    }

    const clickShowAll = () => {
        if(value === 'Origine de la cuisine') startTransition(() => {setShowAll(1)});
        else if(value === 'Type de restaurant') startTransition(() => {setShowAll(2)});
    }
    
    const clickAllDelete = () => {
        if (listFilter.some(item => typeof item === 'number') && resetSearchResto) {resetSearchResto()}
        if(listFilter.includes("Ouvert ce midi") || listFilter.includes("Ouvert ce soir")) {
            setDate_selected(null);
            setHour_selected("");
        }
        if(listFilter.includes("A proximité")) {
            if (!location.pathname.startsWith('/map')) {
                navigate('/');
            }
            setValueSearchCity('')
            setCoordonates({latitude: "",longitude: ""})
            setSearchCity('')
        }
        setListFilter([])
    }

    const addPrice = (nextMin?: number, nextMax?: number) => {
        const min = typeof nextMin === "number" ? nextMin : minValue;
        const max = typeof nextMax === "number" ? nextMax : maxValue;

        const newFilter: [number, number] = [min, max];
        let updatedFilters = [...listFilter];
    
        const index = updatedFilters.findIndex(
            (filter): filter is [number, number] => 
                Array.isArray(filter) && filter.length === 2 && filter.every(num => typeof num === "number")
        );
    
        if (index !== -1) updatedFilters[index] = newFilter;
        else updatedFilters.push(newFilter);
        startTransition(() => {
            setListFilter(updatedFilters);
        });
    };
    const [showCheck, setShowCheck] = useState(false);
    const checkTimerRef = useRef<number | null>(null);
    const triggerCheckAnimation = () => {
        setShowCheck(true);
        if (checkTimerRef.current) window.clearTimeout(checkTimerRef.current);
        checkTimerRef.current = window.setTimeout(() => {
            setShowCheck(false);
            checkTimerRef.current = null;
        }, 1500);
    };

    useEffect(() => {
        return () => {
            if (checkTimerRef.current) window.clearTimeout(checkTimerRef.current);
        };
    }, []);

    const filteredList = useMemo(() => {
        const filtered = principalCuisine.filter((elem) => liste.includes(elem));
        const remaining = liste.filter((elem) => !principalCuisine.includes(elem));
        return [...filtered, ...remaining].slice(0, 5);
    }, [liste]);

    const filteredListSearch = useMemo(() => {
        const filtered = principalCuisine.filter((elem) => liste.includes(elem));
        const remaining = liste.filter((elem) => !principalCuisine.includes(elem));
        return [...filtered, ...remaining];
    }, [liste]);
    const fold = (value: unknown) => {
        if (value == null) return "";
        const s = typeof value === "string" ? value : String(value);
        const lower = s.toLowerCase();
        return /[^\x00-\x7F]/.test(lower)
            ? lower
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/œ/g, "oe")
                .replace(/æ/g, "ae")
                .replace(/ß/g, "ss")
            : lower;
    };

    const listSearch =
        value === "Origine de la cuisine"
            ? (filteredListSearch ?? [])
            : (liste ?? []);

    const listFolded = React.useMemo(
        () => listSearch.map(raw => ({ raw, norm: fold(raw) })),
        [listSearch]
    );
    const needle = React.useMemo(
        () => fold((searchValue || "").trim()),
        [searchValue]
    );
    const shown = React.useMemo(() => {
        if (!needle) return [];
        return listFolded
            .filter(it => it.norm.includes(needle))
            .map(it => it.raw);
    }, [needle, listFolded]);





    return (
        <div className={`containerListFilter ${allDelete   && 'allDelete'}`}>
        { searchValue ? 
        <div className='listeFiltre '> 
            {
                shown.map((elem, index) => (
                   <div key={'elemSearch'+index} className="elem"><InputFilter value={elem} resetSearchResto={resetSearchResto} show={show} id={elem+index.toString()} listFilter={listFilter} setListFilter={setListFilter} /></div>
                )) 
            }
        </div>
        :
        <>
            <div className="titleSection pointer" onClick={clickShow}>
                {
                    show?
                            <FiChevronUp className="Chevron" size={20}  />
                        :  <FiChevronDown className="Chevron" size={20} />
                }
                {
                    show?
                            <FiChevronUp className="ChevronPhone" size={25}  />
                        :  <FiChevronDown className="ChevronPhone" size={25} />
                }
                <p className='title midTitle' style={{fontWeight:'bold'}}>{value}</p>    
                {
                    allDelete && show ? 
                        <div className="allDelete pointer lowOpacityHover" onClick={clickAllDelete}>
                    
                            <p className='XsmallTextBold'>Tout supprimer</p>
                        </div> 
                        : undefined }       
            </div>
            <div className='listeFiltre '>            
                {
                    show && <> {
                        value === 'Origine de la cuisine' ? (
                        
                            filteredList.map((elem, index) => {
                                return <div key={index} className="elem">
                                    <InputFilter
                                        value={elem}
                                        show={show}
                                        id={elem + index.toString()}
                                        listFilter={listFilter}
                                        setListFilter={setListFilter}
                                    />
                                </div>
                        }))
                        : value === 'Type de restaurant' ? 
                                liste && liste.length>0 && liste.slice(0,5).map((elem, index) => (
                                    <div key={index} className="elem"><InputFilter value={elem} show={show} id={elem+index.toString()} listFilter={listFilter} setListFilter={setListFilter} /></div>
                                )) 
                                :
                                liste && liste.length>0 && liste.map((elem, index) => (
                                    <div key={index} className="elem"><InputFilter value={elem} resetSearchResto={resetSearchResto} show={show} id={elem+index.toString()} listFilter={listFilter} setListFilter={setListFilter} /></div>
                                )) 
                    }
                    </>
                          
                }
                    
            </div>
            {
                show && <>{
                    ['Prix par personne', 'Distance'].includes(value)  ? (
                        value === 'Prix par personne' ?  
                            <div className="slideFilter slidePrice slideDobble XsmallText" onTouchStart={(e) => e.stopPropagation()} onTouchMove={(e) => e.stopPropagation()} onTouchEnd={(e) => e.stopPropagation()}> 
                                <div className="value" style={{marginLeft:`${minValue < 50 ? minValue+((50-minValue)/10) : minValue+((50-minValue)/10)+1}%`}}>{minValue+'€'}</div>
                                <div className="pointerValue" style={{marginLeft:`${minValue < 50 ? minValue+((50-minValue)/10) : minValue+((50-minValue)/10)+1}%`}}></div>
                                <div className="value" style={{marginLeft:`${maxValue < 50 ?  maxValue + 3 :  maxValue < 90 ? maxValue : maxValue-3}%`}}>{maxValue === 100 ? '100€+' : maxValue+'€'}</div>
                                <div className="pointerValue" style={{marginLeft:`${maxValue < 50 ?  maxValue + 3 :  maxValue < 90 ? maxValue : maxValue-3}%`}}></div>
                                
                                <div className="patchClose" onTouchStart={(e) => e.stopPropagation()} onTouchMove={(e) => e.stopPropagation()}></div>
                                <div className="range-wrapper" ref={priceWrapperRef}>
                                    <div className="price-touch-zone price-touch-zone-min" style={{ left: 0, width: `${middle}%` }} onTouchStart={(e) => updatePriceFromTouch(e, 'min')} onTouchMove={(e) => updatePriceFromTouch(e, 'min')} />
                                    <div className="price-touch-zone price-touch-zone-max" style={{ left: `${middle}%`, width: `${100 - middle}%` }} onTouchStart={(e) => updatePriceFromTouch(e, 'max')} onTouchMove={(e) => updatePriceFromTouch(e, 'max')} />
                                    <input type="range" aria-label="Prix minimum en euros" id="minRange" min="0" max="100" step={PRICE_STEP} value={minValue} onChange={(e) => handleMinChange(e)}/>
                                    <input type="range" aria-label="Prix maximum en euros" id="maxRange" min="0" max="100" step={PRICE_STEP} value={maxValue} onChange={(e) => handleMaxChange(e)}/>
                                </div>
                                
                                <div className="slider-track" style={{left: `${Math.min(minValue, 88)}%`,width: `${Math.min(99, Math.max(11, maxValue - minValue))}%`}}></div>
                                {showCheck && <span className="checkAnimation"><FiCheck size={20} color="white" /></span>}

                            </div> 
                            :
                            <div className="slideFilter slidePrice XsmallText" onTouchStart={(e) => e.stopPropagation()} onTouchMove={(e) => e.stopPropagation()} onTouchEnd={(e) => e.stopPropagation()}>
                                <div className="patchClose" onTouchStart={(e) => e.stopPropagation()} onTouchMove={(e) => e.stopPropagation()}></div>
                                <div className="value" style={{marginLeft:`${distanceValue <= 50 ?  (distanceValue < 30 ? distanceValue + 4 : distanceValue+2) :  distanceValue < 90 ? distanceValue : distanceValue-3}%`}}>{distanceValue+'km'}</div>
                                <div className="pointerValue" style={{marginLeft:`${distanceValue <= 50 ?  (distanceValue < 30 ? distanceValue + 4 : distanceValue+2) :  (distanceValue < 90 ? distanceValue : distanceValue-3)}%`}}></div>
                                <div className="range-wrapper" ref={distanceWrapperRef}>
                                    <div className="range-touch-area" onTouchStart={handleDistanceTouch} onTouchMove={handleDistanceTouch}/>
                                    <input type="range" aria-label="Distance maximale en kilomètres" id="distanceRange" min="0" max="100" step={5} value={distanceValue} onChange={(e) => handleDistanceChange(e)}/>
                                    <div className="slider-track" style={{left: `0%`,width: `${Math.max(11, Math.min(98, distanceValue))}%`}}></div>
                                </div>
                                {showCheck && <span className="checkAnimationDistance"><FiCheck size={20} color="white" /></span>}
                                   

                            </div>  )
                            :
                            ["Type de restaurant","Origine de la cuisine"].includes(value) ?  
                                <p className={`XsmallTextBold showAllListFilter underlineHover pointer`} onClick={clickShowAll}>Tout afficher</p> 
                                : show  ?
                                    liste.length > 5 && <p className={`XsmallTextBold showAllListFilter underlineHover pointer`} onClick={() => setShow(false)}><i>Afficher moins</i></p> 
                                    : undefined
                    }</>
            }
            {allDelete ? <div className="border"></div>
            : !isLast && <div className="separationBorder"></div>}
            </>}

            
            </div>
    )
}

export {Filter}